<app-mobile-page-back-header iconName="icon-missions-home.svg"><ng-container i18n>Missions</ng-container></app-mobile-page-back-header>

<div *ngIf="isLoading && !isServer else tournaments" style="width: 100%">
  <app-inner-loader></app-inner-loader>
</div>

<ng-template #tournaments>
  <div fxLayout="row wrap" fxLayoutAlign="center" class="card-container">
    <div class="category-menu" fxLayout="row"  fxLayoutAlign="space-between center" >
          <div class="category active" [class.active]="status==='all'" (click)="filterTour('all')"><img src="{{licenceService.getKey('icon-mission-home')}}"/><p i18n>All</p></div>
          <div class="category" [class.active]="status===0" (click)="filterTour(0)"><img src="{{licenceService.getKey('batch-icon-mission')}}"/><p i18n>Active</p></div>
          <div class="category" [class.active]="status===1" (click)="filterTour(1)"><img src="{{licenceService.getKey('batch-icon-schedule')}}"/><p i18n>Upcoming</p></div>
    </div>
    <ng-container *ngFor="let mission of missions; let index=index">
      <app-home-page-mission-card [fromURL]="missionsTrx" routeURL="/{{missionsTrx}}" [mission]="mission" [isEmbedded]="false" [tournamentIndex]="index"></app-home-page-mission-card>
    </ng-container>
  </div>
</ng-template>


<ng-template #gamepresentation>
  <div>{{game}}</div>
</ng-template>

<ng-template #tournamenttitle>
  <div i18n>Tournament</div>
</ng-template>